
import React from 'react';
import { Modal, Button, Form, Input, message } from 'antd';
import { AddWorkOrderNotes } from '../../Services/LocomotiveServices';
import { useState } from 'react';
import { Mention, MentionsInput } from 'react-mentions';
import { utility } from '../../helpers/loader';
import { setPageLoader } from '../../redux/features/utils.slice';
import { useSelector } from 'react-redux';



const NotesModalUpdated = (props) => {

    let { showModal, closeModal, data, setReloadPageByNotesModal } = props

    const [comment, setComment] = useState("")
    let { notesModal } = useSelector(state => state?.utils?.pageLoader)


    const HandleSubmit = async () => {
        utility?.dispatch(setPageLoader({ pageName: "notesModal", flag: true }))

        try {
            const result = await AddWorkOrderNotes(data?.id, { WoNote: comment })

            if (result?.httpStatus === 200) {
                message.success('Note created successfully!');
                setComment("")
                closeModal();
                utility?.dispatch(setPageLoader({ pageName: "notesModal", flag: false }))
                setReloadPageByNotesModal(prev => { return prev = !prev })

            } else {
                message.error('Failed to create note. Please try again.');
                utility?.dispatch(setPageLoader({ pageName: "notesModal", flag: false }))

            }
        } catch (error) {
            console.error('Error submitting note:', error);
            utility?.dispatch(setPageLoader({ pageName: "notesModal", flag: false }))

        }

    }

    const handleChange = (event, newValue, newPlainTextValue, mentions) => {
        setComment(newValue);
    };

    const mentionStyle = {
        control: {
            fontSize: 13,
            fontWeight: 'normal',
            backgroundColor: "white",
        },
        '&multiLine': {
            input: {
                height: 'auto',
                border: '1px solid #ddd',
                padding: '10px',
            },
            highlighter: {
                padding: '10px',
            },
        },
        suggestions: {
            list: {
                backgroundColor: 'white',
                border: '1px solid rgba(0,0,0,0.15)',
                fontSize: 14,
                overflowY: "auto",
                height: "200px"
            },
            item: {
                padding: '5px 15px',
                borderBottom: '1px solid rgba(0,0,0,0.15)',
                '&focused': {
                    backgroundColor: '#cee4e5',
                },
            },
        },
    };


    return (


        <Modal
            title="Add Note"
            visible={showModal}
            onCancel={() => closeModal()}
            footer={
                [
                    <Button key="back" onClick={() => {
                        closeModal()
                        setComment("")
                    }}>
                        Close
                    </Button>,
                    <Button key="submit" type="primary" onClick={HandleSubmit} disabled={comment === "" ? true : notesModal}>
                        OK
                    </Button>,
                ]}
        >
            <MentionsInput
                style={mentionStyle}
                placeholder="Write a note and use @ to mention an employee"
                value={comment}
                onChange={handleChange}
            >
                <Mention
                    trigger="@"
                    data={props?.users?.length ? props?.users?.map(x => ({ id: x.id, display: `${x.firstName ? x.firstName : ""} ${x.lastName ? x.lastName : ""}` })) : []}
                    style={{ backgroundColor: "#cee4e5" }}
                />
            </MentionsInput >
        </Modal >
    );
};

export default NotesModalUpdated;
